import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Engenheiro = () => {
  const wpp = generateWhatsAppLink('engenheiro', 'engenheiro-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Engenheiros | Sustenta LED</title>
        <meta name="description" content="LED para engenheiros: soluções técnicas e robustas. Somos atacadistas e distribuidores com suporte para obras e projetos." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Engenheiros</h1>
              <p>Atendemos engenheiros com soluções LED técnicas e confiáveis para obras, manutenção e retrofits. Somos atacadistas e distribuidores com linhas industriais e comerciais.</p>
              <p>Indicamos especificações com foco em eficiência, segurança elétrica e conformidade normativa.</p>
              <p>Fale com nossa equipe e receba atendimento especializado para seus projetos.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/banner_quemsomos_sustentaled.jpg" alt="LED para Engenheiros - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Engenheiro;
